module.exports = __webpack_public_path__ + "static/img/buss-background.7f7b3c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buss-background.png
// module id = c6i7
// module chunks = 1